<label class="switch" [ngClass]="editable ? '' : 'switch-disabled'">
    <input
        type="checkbox"
        [disabled]="!editable"
        [(ngModel)]="isChecked"
        (change)="onValueChange($event)"
    />
    <span class="slider round"></span>
</label>
